import { render, staticRenderFns } from "./enrollment-payment-follow-up.vue?vue&type=template&id=3e15cfae&"
import script from "./enrollment-payment-follow-up.vue?vue&type=script&lang=ts&"
export * from "./enrollment-payment-follow-up.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports